/**
 * Quiz capilar: dos ejes, un solo flujo.
 *
 * El puntaje es un conteo por valor de metacampo. Cada respuesta suma uno al
 * valor que declara su opción, y al final gana el más votado de cada eje. No es
 * un algoritmo: con tres o cuatro opciones por eje, contar votos da el mismo
 * resultado que cualquier ponderación y se puede explicar en una frase.
 *
 * Las recomendaciones salen del JSON que imprime la sección desde los
 * metacampos, no de handles escritos aquí. Si entra un shampoo nuevo, se
 * etiqueta y aparece solo.
 */
(function () {
  var raiz = document.querySelector("[data-ma-qc]");
  if (!raiz) return;

  var datos = [];
  try {
    datos = JSON.parse(raiz.querySelector("[data-ma-qc-productos]").textContent) || [];
  } catch (e) {
    // Sin catálogo no hay quiz que valga: mejor no arrancar que recomendar nada.
    return;
  }

  var pantallas = {
    intro: raiz.querySelector("[data-ma-qc-intro]"),
    resultado: raiz.querySelector("[data-ma-qc-resultado]"),
  };
  var preguntas = [].slice.call(raiz.querySelectorAll("[data-ma-qc-pregunta]"));
  var progreso = raiz.querySelector("[data-ma-qc-progreso]");
  var puntos = raiz.querySelector("[data-ma-qc-puntos]");
  var barra = raiz.querySelector("[data-ma-qc-barra]");
  var contador = raiz.querySelector("[data-ma-qc-n]");
  var fichas = raiz.querySelector("[data-ma-qc-fichas]");
  var resumen = raiz.querySelector("[data-ma-qc-resumen]");

  var actual = -1; // -1 = intro
  var votos = { cabello: {}, cuero: {}, objetivo: {} };
  var historial = [];
  var elegido = null; // la opción marcada en la pregunta actual, sin confirmar

  function ocultarTodo() {
    pantallas.intro.setAttribute("hidden", "");
    pantallas.resultado.setAttribute("hidden", "");
    preguntas.forEach(function (p) {
      p.setAttribute("hidden", "");
    });
  }

  function pintarProgreso() {
    if (!progreso) return;
    var enPregunta = actual >= 0 && actual < preguntas.length;
    if (!enPregunta) {
      progreso.setAttribute("hidden", "");
      return;
    }
    progreso.removeAttribute("hidden");
    if (barra) barra.style.width = ((actual + 1) / preguntas.length) * 100 + "%";
    if (contador) contador.textContent = actual + 1;
    // Puntitos, como en el quiz de piel: dicen cuánto falta de un vistazo.
    if (puntos && puntos.children.length !== preguntas.length) {
      puntos.replaceChildren();
      preguntas.forEach(function () {
        puntos.appendChild(elem("span", "step-dot"));
      });
    }
    if (puntos) {
      [].forEach.call(puntos.children, function (d, i) {
        d.className = "step-dot" + (i <= actual ? " done" : "");
      });
    }
  }

  function ir(indice) {
    actual = indice;
    ocultarTodo();
    if (indice === -1) {
      pantallas.intro.removeAttribute("hidden");
    } else if (indice < preguntas.length) {
      preguntas[indice].removeAttribute("hidden");
      elegido = null;
      limpiarSeleccion(preguntas[indice]);
    } else {
      mostrarResultado();
      pantallas.resultado.removeAttribute("hidden");
    }
    pintarProgreso();
    // Subir al inicio de la sección, no al de la página: en móvil el quiz
    // empieza a media pantalla y sin esto la pregunta nueva queda fuera de vista.
    raiz.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function ganador(eje) {
    var m = votos[eje];
    var mejor = null;
    var max = 0;
    Object.keys(m).forEach(function (k) {
      if (m[k] > max) {
        max = m[k];
        mejor = k;
      }
    });
    return mejor;
  }

  function tiene(lista, valor) {
    if (!lista || !valor) return false;
    for (var i = 0; i < lista.length; i++) {
      if (String(lista[i]).toLowerCase() === String(valor).toLowerCase()) return true;
    }
    return false;
  }

  function dinero(centavos) {
    if (typeof centavos !== "number") return "";
    return "$" + Math.round(centavos / 100).toLocaleString("es-MX") + " MXN";
  }

  /**
   * La ficha se arma con nodos del DOM, no con innerHTML. No es paranoia: hay
   * productos con comillas en el nombre —Stick Multiusos "Mora"— y metidas en
   * un atributo romperían el marcado.
   */
  function elem(etiqueta, clase, texto) {
    var el = document.createElement(etiqueta);
    if (clase) el.className = clase;
    if (texto != null) el.textContent = texto;
    return el;
  }

  function ficha(p, papel, porque) {
    var art = elem("article", "ma-qc__ficha");

    if (p.imagen) {
      var a = elem("a", "ma-qc__ficha-img");
      a.href = p.url;
      a.tabIndex = -1;
      a.setAttribute("aria-hidden", "true");
      var img = elem("img");
      img.src = p.imagen;
      img.alt = "";
      img.loading = "lazy";
      img.width = 400;
      img.height = 400;
      a.appendChild(img);
      art.appendChild(a);
    }

    var cuerpo = elem("div", "ma-qc__ficha-cuerpo");
    cuerpo.appendChild(elem("p", "ma-qc__ficha-papel", papel));

    var titulo = elem("a", "ma-qc__ficha-titulo", p.titulo);
    titulo.href = p.url;
    cuerpo.appendChild(titulo);

    cuerpo.appendChild(elem("p", "ma-qc__ficha-porque", porque));
    cuerpo.appendChild(elem("p", "ma-qc__ficha-precio", dinero(p.precio)));

    var btn = elem("button", "ma-qc__ficha-add", "Agregar");
    btn.type = "button";
    // data-ma-card-add es el gancho universal de agregar al carrito del tema.
    btn.setAttribute("data-ma-card-add", "");
    btn.setAttribute("data-variant-id", p.variante);
    cuerpo.appendChild(btn);

    art.appendChild(cuerpo);
    return art;
  }

  function mostrarResultado() {
    var cab = ganador("cabello");
    var cue = ganador("cuero");
    var obj = ganador("objetivo");

    fichas.replaceChildren();
    var avisoPrevio = raiz.querySelector(".ma-qc__sin-suero");
    if (avisoPrevio) avisoPrevio.remove();
    var puestos = {};

    function agregar(p, papel, porque) {
      if (!p || puestos[p.handle]) return;
      puestos[p.handle] = true;
      fichas.appendChild(ficha(p, papel, porque));
    }

    // 1. Shampoo por tipo de cabello. Si además hay un objetivo declarado y
    //    existe un shampoo para ese objetivo, ese manda: quien busca
    //    crecimiento lo busca antes que el ajuste fino de su tipo.
    var shampoos = datos.filter(function (p) {
      return /shampoo/i.test(p.titulo);
    });
    var shObjetivo = obj
      ? shampoos.filter(function (p) {
          return tiene(p.objetivo, obj);
        })[0]
      : null;
    var shCabello = shampoos.filter(function (p) {
      return tiene(p.cabello, cab);
    })[0];
    var shCuero = shampoos.filter(function (p) {
      return tiene(p.cuero, cue);
    })[0];

    if (shObjetivo) {
      agregar(shObjetivo, "Tu shampoo", "Porque tu prioridad es " + obj.toLowerCase() + ".");
    } else if (shCuero && cue === "Sensible") {
      // El cuero cabelludo sensible pesa más que el tipo de cabello: si pica,
      // eso es lo que hay que resolver primero.
      agregar(shCuero, "Tu shampoo", "Porque tu cuero cabelludo está sensible.");
    } else if (shCabello) {
      agregar(shCabello, "Tu shampoo", "Para cabello " + cab.toLowerCase() + ".");
    }

    // 2. Suero por cuero cabelludo, con el objetivo por delante si aplica.
    var sueros = datos.filter(function (p) {
      return /suero/i.test(p.titulo);
    });
    var suObjetivo = obj
      ? sueros.filter(function (p) {
          return tiene(p.objetivo, obj);
        })[0]
      : null;
    var suCuero = sueros.filter(function (p) {
      return tiene(p.cuero, cue);
    })[0];
    var huboSuero = false;
    if (suObjetivo) {
      agregar(suObjetivo, "Tu suero", "Porque buscas " + obj.toLowerCase() + ".");
      huboSuero = true;
    } else if (suCuero) {
      agregar(suCuero, "Tu suero", "Para cuero cabelludo " + cue.toLowerCase() + ".");
      huboSuero = true;
    }

    // 3. El acondicionador va siempre: sirve para todos los tipos y es el
    //    complemento natural de cualquier shampoo sólido.
    var acond = datos.filter(function (p) {
      return /acondicionador/i.test(p.titulo) && tiene(p.cabello, cab);
    })[0];
    agregar(acond, "Y el complemento", "Sirve para todos los tipos de cabello.");

    // 4. Si hay un kit que cubre lo mismo, se ofrece como alternativa de "todo
    //    junto". Antes nunca aparecía: el shampoo suelto ganaba siempre el
    //    primer lugar y el kit se quedaba fuera del resultado.
    var kit = datos.filter(function (p) {
      return /^kit/i.test(p.titulo) && (tiene(p.objetivo, obj) || tiene(p.cabello, cab));
    })[0];
    agregar(kit, "O todo junto", "El kit trae la rutina completa en un solo pedido.");

    // Decirlo cuando no hay suero para su caso es mejor que dejar el resultado
    // corto y que parezca que se nos olvidó. Y de paso marca el hueco de
    // catálogo: hoy no hay suero para cuero cabelludo graso ni sensible.
    if (!huboSuero && cue) {
      var aviso = elem(
        "p",
        "ma-qc__sin-suero",
        "Todavía no tenemos un suero específico para cuero cabelludo " +
          cue.toLowerCase() +
          ". El shampoo de arriba sí lo trabaja."
      );
      fichas.parentNode.insertBefore(aviso, fichas.nextSibling);
    }

    var partes = [];
    if (cab) partes.push("cabello " + cab.toLowerCase());
    if (cue) partes.push("cuero cabelludo " + cue.toLowerCase());
    resumen.textContent = partes.length
      ? "Tienes " + partes.join(" y ") + "."
      : "Esto es lo que te recomendamos.";
  }

  function limpiarSeleccion(pantalla) {
    [].forEach.call(pantalla.querySelectorAll(".opt"), function (o) {
      o.classList.remove("selected");
      var chk = o.querySelector(".opt-check");
      if (chk) chk.textContent = "";
    });
    var sig = pantalla.querySelector("[data-ma-qc-siguiente]");
    if (sig) sig.disabled = true;
  }

  function marcar(op) {
    var pantalla = op.closest("[data-ma-qc-pregunta]");
    limpiarSeleccion(pantalla);
    op.classList.add("selected");
    var chk = op.querySelector(".opt-check");
    if (chk) chk.textContent = "✓";
    elegido = { eje: pantalla.getAttribute("data-eje"), valor: op.getAttribute("data-valor") };
    var sig = pantalla.querySelector("[data-ma-qc-siguiente]");
    if (sig) sig.disabled = false;
  }

  function confirmar() {
    if (!elegido) return;
    if (elegido.valor && votos[elegido.eje]) {
      votos[elegido.eje][elegido.valor] = (votos[elegido.eje][elegido.valor] || 0) + 1;
    }
    historial.push(elegido);
    ir(actual + 1);
  }

  raiz.addEventListener("click", function (e) {
    if (e.target.closest("[data-ma-qc-empezar]")) {
      ir(0);
      return;
    }
    var op = e.target.closest("[data-ma-qc-responder]");
    if (op) {
      marcar(op);
      return;
    }
    if (e.target.closest("[data-ma-qc-siguiente]")) {
      confirmar();
      return;
    }
    if (e.target.closest("[data-ma-qc-atras]")) {
      var ultimo = historial.pop();
      if (ultimo && ultimo.valor && votos[ultimo.eje]) {
        votos[ultimo.eje][ultimo.valor] -= 1;
      }
      ir(Math.max(-1, actual - 1));
      return;
    }
    if (e.target.closest("[data-ma-qc-reiniciar]")) {
      votos = { cabello: {}, cuero: {}, objetivo: {} };
      historial = [];
      elegido = null;
      ir(-1);
    }
  });

  // Las opciones son divs con role=button: sin esto no se pueden usar con teclado.
  raiz.addEventListener("keydown", function (e) {
    if (e.key !== "Enter" && e.key !== " ") return;
    var op = e.target.closest("[data-ma-qc-responder]");
    if (!op) return;
    e.preventDefault();
    marcar(op);
  });
})();
